<div class="report-manager">
  <div class="controls-row">
    <!-- Agences -->
    <div class="control-group">
      <label>Agences</label>
      <div class="agencies-select-wrapper">
        <button type="button" class="agencies-toggle" (click)="toggleAgenciesDropdown()">
          {{ selectedAgenciesLabel() }} ▾
        </button>
        <div class="agencies-dropdown" *ngIf="showAgenciesDropdown">
          <label class="all-check">
            <input type="checkbox" [checked]="isAllSelected()" (change)="selectAllAgencies($event.target.checked)">
            Tout sélectionner
          </label>
          <div class="bank-item" *ngFor="let a of agencies">
            <label>
              <input type="checkbox" [checked]="isAgencySelected(a.id)" (change)="toggleAgency(a.id)">
              {{ a.name }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Période -->
    <div class="control-group">
      <label>Période</label>
      <div class="date-range-wrapper">
        <div class="input-with-label">
          <span>Du</span>
          <input type="date" [(ngModel)]="startDate" class="sub-input" />
        </div>
        <div class="input-with-label">
          <span>Au</span>
          <input type="date" [(ngModel)]="endDate" class="sub-input" />
        </div>
      </div>
    </div>

    <!-- Checkboxes -->
    <div class="control-group check-group">
      <label class="checkbox-label highlight">
        <input type="checkbox" [(ngModel)]="isLastTransfer"> Dernier lot
      </label>
    </div>
    <!-- Mode Démo removed -->

    <div class="control-group action-btn">
      <button (click)="applyFilters()" [disabled]="loading" class="btn-filter">
        {{ loading ? 'chargement' : 'Filtrer' }}
      </button>
    </div>
  </div>

  <!-- Légende -->
  <div class="status-legend-bar">
    <div class="legend-item" *ngFor="let s of statusMapping; let i = index">
      <span class="badge" [style.background]="statusColors[i]">{{ s.short }}</span> : {{ s.full }}
    </div>
  </div>

  <!-- Ligne 1 : Doughnuts -->
  <div class="charts-grid">
    <div class="chart-card">
      <h3><strong>Répartition des polices</strong></h3>
      <div class="canvas-container">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #countsCanvas
          (dblclick)="handleChartClick($event, 'counts')"></canvas>
      </div>
    </div>
    <div class="chart-card">
      <h3><strong>Répartition du CA</strong></h3>
      <div class="canvas-container">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #caCanvas (dblclick)="handleChartClick($event, 'ca')"></canvas>
      </div>
    </div>
  </div>

  <!-- Ligne 2 : Histogrammes (Status sur axe X) -->
  <div class="charts-grid">
    <div class="chart-card">
      <h3><strong>Volume par Statut</strong></h3>
      <div class="canvas-container-bar">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #compCountsCanvas
          (dblclick)="handleChartClick($event, 'compCounts')"></canvas>
      </div>
    </div>
    <div class="chart-card">
      <h3><strong>CA par Statut</strong></h3>
      <div class="canvas-container-bar">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #compCaCanvas
          (dblclick)="handleChartClick($event, 'compCa')"></canvas>
      </div>
    </div>
  </div>
</div>
